<template>
  <VodEpisodeCellList
    v-if="isVodEpisode"
    key="infinite_vod_episode_list"
    :cell-list="cellList"
    :thumbnail-info="thumbnailInfo"
    :content-info="contentInfo"
    v-infinite-scroll="loadMore"
    infinite-scroll-distance="100"
    infinite-scroll-throttle-delay="200"
  />
  <MovieSeriesCellList
    v-else
    key="infinite_movie_series_list"
    :cell-list="cellList"
    :thumbnail-info="thumbnailInfo"
    :content-info="contentInfo"
    v-infinite-scroll="loadMore"
    infinite-scroll-distance="100"
    infinite-scroll-throttle-delay="200"
  />
</template>
<script>
import { infiniteScroll } from '@/common/directives'
import VodEpisodeCellList from '@/components/play/bottom-tab/VodEpisodeCellList'
import MovieSeriesCellList from '@/components/play/bottom-tab/MovieSeriesCellList'

export default {
  name: 'InfiniteScrollSeriesCellList',
  // props: ['cellList', 'thumbnailInfo', 'contentInfo'],
  components: { MovieSeriesCellList, VodEpisodeCellList },
  props: {
    cellList: {
      type: Array,
      default: null
    },
    thumbnailInfo: {
      type: Object,
      default: () => ({})
    },
    contentInfo: {
      type: Object,
      default: () => ({})
    },
    section: {
      type: String,
      default: ''
    }
  },
  computed: {
    isVodEpisode () {
      return this.section === 'vod'
    }
  },
  methods: {
    loadMore () {
      this.$emit('load-more')
    }
  },
  directives: {
    infiniteScroll
  }
}
</script>
